import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Firebase proje konfigürasyonu
// Bu bilgiler Firebase Console'dan alınmıştır
// Proje kimlik bilgileri ve API anahtarları
const firebaseConfig = {
  apiKey: "AIzaSyBzr2h-BHt8AvCzgdkQ8ry2M676pKCMpa8",
  authDomain: "whereismypet-5b62c.firebaseapp.com",
  projectId: "whereismypet-5b62c",
  storageBucket: "whereismypet-5b62c.firebasestorage.app",
  messagingSenderId: "70825126088",
  appId: "1:70825126088:web:3e72f3f99ebdeff4ca9dfd",
  measurementId: "G-WZ24NLNW5F"
};

// Firebase uygulamasının başlatılması
const app = initializeApp(firebaseConfig);

// Firebase servislerinin dışa aktarılması
// auth: Kullanıcı kimlik doğrulama işlemleri için
// db: Firestore veritabanı işlemleri için
// storage: Dosya depolama işlemleri için
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app); 